import React, { Component } from 'react'
import { compose } from 'react-apollo'
import { DragSource, DropTarget } from 'react-dnd'
import PropTypes from 'prop-types'
import moment from 'moment'
import _ from 'lodash'

class Day extends Component {
  static propTypes = {
    day: PropTypes.object,
    index: PropTypes.number,
    isActive: PropTypes.bool,
    onDaySelect: PropTypes.func,
    getFav: PropTypes.func,
    connectDropTarget: PropTypes.func,
    connectDragSource: PropTypes.func,
    isDragging: PropTypes.bool,
    findDay: PropTypes.func,
    moveDay: PropTypes.func,
    setHoveredDay: PropTypes.func
  }

  static defaultProps = {
    day: {},
    isActive: false,
    onDaySelect: () => ({}),
    getFav : () => ({})
  }

  renderIcons(day) {
    return _(day.eventItineraryDays[0].ContentEvents)
      .map(e => e.type)
      .uniq()
      .map((type, i) => <img key={i} className="day__icon" src={`/img/trip-planner/${type}.svg`} alt="" />)
      .value()
  }

  render() {
    return this.props.connectDropTarget(
      this.props.connectDragSource(
        
        <div
          className="sidebar__day day"
          style={{
            opacity: this.props.isDragging ? 0 : 1
          }}
          onClick={() => {
            this.props.onDaySelect(this.props.index)
            this.props.getFav(this.props)
          }}
        >
          <div>
            <div className="day__name">
              {this.props.day.dayoftrip ? moment(this.props.day.dayoftrip).format('MMM Do, ddd') : this.props.day.title}
            </div>
            <div className="day__title">{this.props.day.title ? this.props.day.title : ''}</div>
          </div>
          <div className="day__icons">
            {this.renderIcons(this.props.day)}
            {this.props.isActive ? <i className="day__icon icon-arrow-next-1" style={{ fontWeight: 'bold' }} /> : null}
          </div>
        </div>
      )
    )
  }
}

export default compose(
  DropTarget(
    'day',
    {
      canDrop: () => false,
      hover(props, monitor) {
        const item = monitor.getItem()

        if (item.id !== props.day.id) {
          props.setHoveredDay(props.day)
        }
      }
    },
    connect => ({
      connectDropTarget: connect.dropTarget()
    })
  ),
  DragSource(
    'day',
    {
      beginDrag: props => ({
        id: props.day.id,
        originalIndex: props.findDay(props.day.id).index
      }),
      endDrag(props, monitor) {
        const item = monitor.getItem()
        const didDrop = monitor.didDrop()

        if (didDrop) {
          props.moveDay(item.id)
        }
      }
    },
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging()
    })
  )
)(Day)



// WEBPACK FOOTER //
// src/components/TripPlanner/Day.js